import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const PeriodoCard = ({ periodo }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h5" component="div">
          {periodo.nome}
        </Typography>
        <Typography color="text.secondary">
          Campanha: {periodo.campanha?.nome || 'Não associada'}
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          Total de Pré-Inscrições: {periodo.preInscricoes?.length || 0}
        </Typography>
        <Button 
          component={Link} 
          to={`/periodos/${periodo.id}`} 
          variant="contained" 
          color="primary" 
          sx={{ mt: 2 }}
        >
          Ver Detalhes
        </Button>
      </CardContent>
    </Card>
  );
};

PeriodoCard.propTypes = {
  periodo: PropTypes.shape({
    nome: PropTypes.string.isRequired,
    campanha: PropTypes.shape({
      nome: PropTypes.string,
    }),
    preInscricoes: PropTypes.arrayOf(PropTypes.object),
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default PeriodoCard;
